module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-b9b5d7ed.png";